import axios from "axios";
import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { Link, useParams } from "react-router-dom";
import Loader from "../../../Components/Global/Loader";
import DashboardLayouts from "../../../Components/Layout/DashboardLayouts";
import { useAuth } from "../../../Context/AuthContext";

import useAuthentication from "../../../hooks/useAuthentication";
import useAxiosFetch from "../../../hooks/useAxiosFetch";
import DummyImg from "../../../Public/Images/568165.png";

function RequestDetails({ allowedRoles }) {
  const { allowLoading } = useAuthentication(allowedRoles);

  const [requestData, setRequestData] = useState([]);
  const [viewImage, setViewImage] = useState([]);
  const [showImage, setShowimage] = useState();
  // api api from global hook 

  const { axiosFetch} = useAxiosFetch();
  const { designation } = useAuth();

  let ID = useParams();
  const request_Id = ID?.id;

  const onClickImages = (e, url) => {
    e.preventDefault(url);
    setShowimage(url);
  };
  useEffect(() => {
    if (request_Id) {
      axiosFetch({
        axiosInstance: axios,
        method: "GET",
        url: `/request/show/${request_Id}`,
      })
        .then((response) => {
          if (response.data) {
            setRequestData(response.data);
            setViewImage(JSON.parse(response?.data?.request_image));
          }
        })
        .catch((e) => {
          //   setLoading(false);
       
        });
    }
  }, []);

  return (
    <DashboardLayouts>
      {allowLoading && <Loader />}
      <div className="breadcrumb row justify-content-between align-items-center">
        <div className="col-xl-6 d-flex align-items-center dashboard-upper-menu col-md-6 col-auto">
          <Link to="/dashboard" className="d-flex align-items-center back-link">
            <BsArrowLeft className="me-2 back-arrow m-0 " color="black" />
            <i className="icon-dashboard"></i>
            <h3 className="mb-0 fw-normal">Dashboard</h3>
          </Link>
        </div>

        <div className="col-auto btn-responsive">
          <Link
            to={
              designation === "Owner" || designation === "Partner"
                ? "/view-request"
                : `/${designation?.toLowerCase()}/view-request`
            }
            className="btn btn-outline-primary me-2"
          >
            Back to Request list
          </Link>
        </div>
      </div>

      <div className="w-100 list-data">
        <h1 className="heading-text mb-4">View Request</h1>
      </div>
      <h1 className="task-heading">{requestData?.task_title}</h1>
      <section className="w-100 mt-2 task-details mb-5 ">
        <div className="row justify-content-between pt-0 pt-lg position-relative">
          <div className="col-xl-7 left col-md-auto col-lg-auto">
            <ul className="req-detail-list mb-3">
              <li>
                <span>Tenant Name :</span>
                <p>
                  {requestData?.tenantfirst_name +
                    " " +
                    requestData?.tenantmiddle_name +
                    " " +
                    requestData?.tenantlast_name}
                </p>
              </li>
              <li>
                <span>Unit :</span>
                <p>{requestData?.unit_name}</p>
              </li>
              <li>
                <span>Building Name :</span>
                <p>{requestData?.building_name}</p>
              </li>
              <li>
                {/* <p>Priority :</p>
                <span>
                  {requestData?.priority ? requestData?.priority : "N/A"}
                </span> */}
              </li>
              <li>
                <span>Request Receiver :</span>
                <p>
                  {requestData?.RequestAssigns?.map((list, index) => (
                    <p key={index}>
                      {list?.first_name +
                        " " +
                        list?.middle_name +
                        " " +
                        list?.last_name}
                    </p>
                  ))}
                </p>
              </li>
              <li>
                <span>Description :</span>
                <p>{requestData?.description}</p>
              </li>
            </ul>
            <div className="btn-wrp convert_to_text_btn_position_chng">
              <Link
                to={
                  designation === "Owner" || designation === "Partner"
                    ? `/addtask?taskid=${request_Id}`
                    : `/${designation.toLowerCase()}/addtask?taskid=${request_Id}`
                }
                type="submit"
                className="btn btn-primary "
                data-bs-toggle="modal"
                data-bs-target="#exampleModalCenter"
              >
                Convert To Task
              </Link>
            </div>
          </div>
          <div className="col-xl-5 right d-flex h-100 align-items-center justify-content-md-start justify-content-xl-end mt-md-4 mt-xl-0">
            <div className="area-hide add-building-img">
              <div className="image-area d-flex align-items-center justify-content-center position-relative">
                <div>
                  {viewImage?.length > 0 || showImage ? (
                    viewImage?.slice(0, 1)?.map((url, i) => {
                      return (
                        <div key={i}>
                          <img
                            id="show-image"
                            src={showImage ? showImage : url}
                            alt=""
                          />
                        </div>
                      );
                    })
                  ) : (
                    <img id="show-image" src={DummyImg} alt="" />
                  )}
                </div>
                <div></div>
              </div>
              <div className="add-images d-flex ">
                {viewImage?.map((url, index) => (
                  <div className="img-sec">
                    <img
                      id="show-image"
                      src={viewImage.length >= 1 ? url : DummyImg}
                      alt=""
                      onClick={(e) => onClickImages(e, url)}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </DashboardLayouts>
  );
}
export default RequestDetails;
